import Login from "../../views/login/Index.vue";
import AuthCallback from "../../views/login/AuthCallback.vue";

const LoginRoute = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    // Target of the backend after the Microsoft sign in (?code=<one-time code>)
    path: '/auth/callback',
    name: 'AuthCallback',
    component: AuthCallback,
  },
];

export default LoginRoute;
